module.exports = __webpack_public_path__ + "img/logo_next.1f75fb89.png";